module.exports = __webpack_public_path__ + "public/images/generated-geometry.6dd25ae51af3f0db1c6b51154606fdb0.jpg";